module.exports = __webpack_public_path__ + "media/images/logo_eim_blue-56d8d18d.png";